import React, { useState, useRef } from 'react';
import PinInput from 'react-pin-input';
import graph from './graph';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { useMutation } from '@apollo/client';
import { isEmptyObject } from 'helpers/formatObject';
import { CircularProgress, Dialog, Button, DialogContent, Stack, Typography, Box } from '@mui/material';

import CanvasDraw from 'react-canvas-draw';

// ----------------------------------------------------------------------

export default function GiveOrder({ ids, refetch }) {
  const { userToken } = useSelector((state) => state.auth);
  const [open, setOpen] = useState(false);
  const [shippingCode, setShippingCode] = useState('');
  const [isComplete, setComplete] = useState(false);
  const [sign, setSign] = useState(null);
  const canvas = useRef(null);

  const handleClose = () => {
    setSign(null);
    setOpen(false);
  };
  const handleOpen = () => setOpen(true);

  const [handleDone, { loading }] = useMutation(graph.deliveryOrder.query, {
    context: {
      serviceName: graph.deliveryOrder.serviceName,
      headers: {
        authorization: `Bearer ${userToken}`,
      },
    },
  });

  const onDone = async () => {
    try {
      if (!shippingCode) {
        return toast.warning('لطفا کد حمل را وارد نمایید!');
      }
      setSign(canvas.current.getSaveData());
      const sign = canvas.current.getDataURL();
      setComplete(true);
      const { data } = await handleDone({
        variables: { order_id: ids, shipping_code: shippingCode, sign_file: sign },
      });
      if (!isEmptyObject(data)) {
        refetch();
        data[graph.deliveryOrder.name]?.messages.map((message) => toast.success(String(message)));
      }
    } catch (error) {
      setComplete(false);
      console.log('error', error);
    }
  };

  const onClear = () => {
    setSign(null);
    canvas.current.clear();
  };

  return (
    <>
      <Button sx={{ width: 140 }} size="small" variant="contained" color="secondary" onClick={handleOpen}>
        {loading ? <CircularProgress color="secondary" size={28} /> : 'تحویل بسته'}
      </Button>
      <Dialog
        dir="rtl"
        fullWidth
        maxWidth="sm"
        open={open}
        onClose={handleClose}
        PaperComponent={Box}
        PaperProps={{ sx: { px: 1, py: 3, m: 0, width: '100%' } }}
      >
        <DialogContent sx={{ p: 0 }}>
          <Stack rowGap={2} width="100%" alignItems="center">
            <Typography variant="subtitle1" color="#fff">
              کد حمل و امضای مشتری
            </Typography>
            {/* <Typography variant="subtitle2" fontSize={13} color="#fff">
              لطفا کد حمل را از مشتری دریافت کرده و وارد نمایید
            </Typography> */}
            <PinInput
              focus
              length={5}
              autoSelect
              initialValue=""
              type="numeric"
              inputMode="number"
              inputFocusStyle={{
                borderColor: 'blue',
              }}
              inputStyle={{
                color: '#fff',
                borderRadius: 8,
                borderColor: '#ccc',
              }}
              style={{
                width: 300,
                display: 'flex',
                direction: 'ltr',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
              disabled={isComplete}
              onComplete={(value) => setShippingCode(value)}
            />
            <Stack
              width={300}
              height={300}
              justifyContent="center"
              alignItems="center"
              overflow="hidden"
              borderRadius={2}
              position="relative"
            >
              {sign && (
                <CanvasDraw
                  disabled
                  saveData={sign}
                  hideGrid
                  canvasWidth={300}
                  canvasHeight={300}
                  style={{ position: 'absolute', zIndex: 100, top: 0, left: 0 }}
                />
              )}
              <CanvasDraw brushRadius={1} lazyRadius={0} canvasHeight={300} canvasWidth={300} ref={canvas} />
            </Stack>

            <Stack width={300} direction="row" columnGap={2}>
              <Button fullWidth size="small" variant="contained" color="secondary" onClick={onDone}>
                تایید
              </Button>
              <Button fullWidth size="small" variant="outlined" color="error" onClick={onClear}>
                پاک کردن
              </Button>
              {/* <Button onClick={() => console.log(canvas.current.getSaveData())}>getSaveData</Button> */}
            </Stack>
          </Stack>
        </DialogContent>
        {/* <DialogActions>
          <Button fullWidth disableRipple onClick={onDone} disabled={loading}>
            مشاهده همه
          </Button>
        </DialogActions> */}
      </Dialog>
    </>
  );
}
